// extracted by mini-css-extract-plugin
module.exports = {"orgUnitCard":"sidebar_orgUnitCard__2YwBA","memberTitle":"sidebar_memberTitle__3JSpX","infiniteScroll":"sidebar_infiniteScroll__UZV6c"};